/* eslint-disable max-len */
/*
setExcludeValue = (fieldsValues) => true|false; // this is used to exclude the value of the current field from bieng added to the form values.
setVisibility = (fieldsValues) => true|false;
*/
import { objSafeProps } from 'utils';

export const formField = {
  text: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, onChange, error, helpText, ...props
  }) => objSafeProps({
    type: 'text', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, onChange, error, helpText, ...props,
  }),

  number: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, onChange, error, helpText, ...props
  }) => objSafeProps({
    type: 'number', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, onChange, error, helpText, ...props,
  }),

  password: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, onChange, error, helpText, ...props
  }) => objSafeProps({
    type: 'password', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, onChange, error, helpText, ...props,
  }),

  switch: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, helpText, ...props
  }) => objSafeProps({
    type: 'switch', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, helpText, ...props,
  }),

  dropdown: ({
    name, title, setTitle, visible, setVisibility, updateProps, getOptionsStoreMap, setValueFrom, setValueTo, setExcludeValue, error, helpText, options, ...props
  }) => objSafeProps({
    type: 'dropdown', name, title, setTitle, visible, setVisibility, updateProps, getOptionsStoreMap, setValueFrom, setValueTo, setExcludeValue, error, helpText, options, ...props,
  }),

  range: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, helpText, range, ...props
  }) => objSafeProps({
    type: 'range', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, helpText, range, ...props,
  }),

  slider: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, helpText, range, showValue, ...props
  }) => objSafeProps({
    type: 'slider', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, helpText, range, showValue, ...props,
  }),

  array: ({
    name, title, setTitle, subTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, helpText, fields, validations, setItemTitle, setItemDetails, fieldsValues, isAddButton, actionButtonName, icon, maxItems, ...props
  }) => objSafeProps({
    type: 'array', name, title, setTitle, subTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, helpText, fields, validations, setItemTitle, setItemDetails, fieldsValues, isAddButton, actionButtonName, icon, maxItems, ...props,
  }),

  object: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, helpText, fields, validations, ...props
  }) => objSafeProps({
    type: 'object', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, helpText, fields, validations, ...props,
  }),

  userData: ({
    name, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'user-data', name, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  autocomplete: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, helpText, options, ...props
  }) => objSafeProps({
    type: 'autocomplete', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, helpText, options, ...props,
  }),

  ip: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'ip', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  rangeBasic: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'range-basic', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  port: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'port', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  timeRange: ({
    name, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, ...props
  }) => objSafeProps({
    type: 'time-range', name, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, ...props,
  }),

  ips: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'ips', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  lans: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'lans', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  location: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'location', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  nic: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'nic', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  lan: ({
    name, title, setTitle, visible, privateOnly, hasNewOption, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'lan', name, title, setTitle, visible, privateOnly, hasNewOption, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  textarea: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'textarea', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  cdRom: ({
    name, title, setTitle, visible, locationId, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'cdrom', name, title, setTitle, visible, locationId, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  hdd: ({
    name, title, setTitle, visible, locationId, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'hdd', name, title, setTitle, visible, locationId, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  datacenter: ({
    name, visible, setVisibility, location, updateProps, setValueFrom, setValueTo, setExcludeValue, error, valueFilterFn, ...props
  }) => objSafeProps({
    type: 'datacenter', name, visible, setVisibility, location, updateProps, setValueFrom, setValueTo, setExcludeValue, error, valueFilterFn, ...props,
  }),

  user: ({
    name, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, ...props
  }) => objSafeProps({
    type: 'user', name, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, ...props,
  }),

  volume: ({
    name, dcId, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'volume', name, dcId, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  boot: ({
    name, options, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'boot', name, options, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  resource: ({
    name, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, ...props
  }) => objSafeProps({
    type: 'resource', name, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, ...props,
  }),

  group: ({
    name, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, ...props
  }) => objSafeProps({
    type: 'group', name, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, ...props,
  }),

  time: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, ...props
  }) => objSafeProps({
    type: 'time', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, ...props,
  }),

  dateTime: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, ...props
  }) => objSafeProps({
    type: 'date-time', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, ...props,
  }),

  mobileDateTime: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, ...props
  }) => objSafeProps({
    type: 'mobile-date-time', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, ...props,
  }),

  label: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, style, helpText, ...props
  }) => objSafeProps({
    type: 'label', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, style, helpText, ...props,
  }),

  toggle: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, style, helpText, ...props
  }) => objSafeProps({
    type: 'toggle', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, style, helpText, ...props,
  }),

  server: ({
    name, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'server', name, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  monitorAction: ({
    name, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'monitor-action', name, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  commonSelector: ({
    name, visible, setVisibility, subTitle, helpText, isCollapsed, isMultiple, isFilter, filterByPropName, setItemTitle, setItemDetails, itemIcon, itemIconColor, setItemIconText, valuePropName, returnValuePropOnly, getItemsStoreMap, items, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'common-selector', name, visible, setVisibility, subTitle, helpText, isCollapsed, isMultiple, isFilter, filterByPropName, setItemTitle, setItemDetails, itemIcon, itemIconColor, setItemIconText, valuePropName, returnValuePropOnly, getItemsStoreMap, items, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),

  fileReader: ({
    name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props
  }) => objSafeProps({
    type: 'file-reader', name, title, setTitle, visible, setVisibility, updateProps, setValueFrom, setValueTo, setExcludeValue, error, ...props,
  }),
};
